var _g, _g2, _g3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnalytics = function SvgAnalytics(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 3,
    height: 5,
    rx: 1,
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 3,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 3,
    height: 10,
    rx: 1,
    fill: "currentColor"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4,
    width: 3,
    height: 16,
    rx: 1,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnalytics);
export { ForwardRef as ReactComponent };